// src/App.js

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import MainLayout from "./components/templates/MainLayout";
import HomePage from "./components/pages/HomePage";
import ViewAllChallengesPage from "./components/pages/ViewAllChallengesPage";
import ViewAllSubmissionsPage from "./components/pages/ViewAllSubmissionsPage";
import UserProfile from "./components/pages/UserProfile";
import ChallengeDetailPage from "./components/pages/ChallengeDetailPage";
import SubmissionDetailPage from "./components/pages/SubmissionDetailPage";
import SignInPage from "./components/pages/SignInPage";
import SignUpPage from "./components/pages/SignUpPage";
import ChallengeCreatorPage from "./components/pages/ChallengeCreator/ChallengeCreatorPage";
import ChallengeSubmissionPage from "./components/pages/ChallengeSubmissionPage";
import SuccessPage from "./components/pages/ChallengeSubmission/SuccessPage";
import FailurePage from "./components/pages/ChallengeSubmission/FailurePage";
import ProfileEditPage from "./components/pages/ProfileEditPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { theme } from "./theme";
import GlobalStyles from "./GlobalStyles";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import ViewAllSubmissionContributionsPage from "./components/pages/ViewAllSubmissionContributions";
// import SubmissionMigrationPage from "./components/pages/SubmissionMigrationPage";
import SocialVideo from "./components/pages/SocialVideo";
import VideoInteractions from "./components/pages/VideoInteractions";
import CAPMembershipPage from "./components/pages/CAPMembershipPage";
import WatchingPage from "./components/pages/WatchingPage";
import HoldingDetailPage from "./components/pages/HoldingDetailPage";

const App = () => {
  return (
    <PayPalScriptProvider
      options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID }}
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles /> {/* Apply GlobalStyles */}
        <Router>
          <MainLayout>
            <Routes>
              {/* <Route
                path="/challenge/submission/migration"
                element={
                  <ProtectedRoute>
                    <SubmissionMigrationPage />
                  </ProtectedRoute>
                }
              /> */}

              <Route path="/challenge/" element={<HomePage />} />
              <Route
                path="/challenge/:challengeId"
                element={<ChallengeDetailPage />}
              />

              <Route
                path="/challenge/all/"
                element={<ViewAllChallengesPage />}
              />

              <Route
                path="/challenge/submissions/all/"
                element={<ViewAllSubmissionsPage />}
              />

              <Route
                path="/challenge/submissions/all/:challengeId"
                element={<ViewAllSubmissionsPage />}
              />

              <Route
                path="/challenge/submissions/all/:userId"
                element={<ViewAllSubmissionsPage />}
              />

              <Route
                path="/challenge/submission/:submissionId"
                element={<SubmissionDetailPage />}
              />

              <Route
                path="/challenge/submission/contributions/:submissionId/amount/:contributionAmount"
                element={
                  <ProtectedRoute>
                    <ViewAllSubmissionContributionsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/submission/contributions/"
                element={
                  <ProtectedRoute>
                    <ViewAllSubmissionContributionsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/contributions/view"
                element={
                  <ProtectedRoute>
                    <HoldingDetailPage />
                  </ProtectedRoute>
                }
              />

              <Route path="/challenge/signin" element={<SignInPage />} />
              <Route path="/challenge/connect" element={<SignInPage />} />
              <Route path="/challenge/signup" element={<SignUpPage />} />

              {/* Route for /profile with and without profileId */}
              <Route path="/challenge/profile" element={<UserProfile />} />
              <Route
                path="/challenge/profile/:profileId"
                element={<UserProfile />}
              />
              <Route
                path="/challenge/profile/:profileId/challenges"
                element={<ViewAllChallengesPage />}
              />

              <Route
                path="/challenge/create"
                element={
                  <ProtectedRoute>
                    <ChallengeCreatorPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/challenge/edit/:challengeId"
                element={
                  <ProtectedRoute>
                    <ChallengeCreatorPage />
                  </ProtectedRoute>
                }
              />

              {/* Route for new submission (no submissionId) */}
              <Route
                path="/challenge/:challengeId/submission/new"
                element={
                  <ProtectedRoute>
                    <ChallengeSubmissionPage />
                  </ProtectedRoute>
                }
              />

              {/* Route for editing existing submission */}
              <Route
                path="/challenge/:challengeId/submission/:submissionId"
                element={
                  <ProtectedRoute>
                    <ChallengeSubmissionPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/profile/edit"
                element={
                  <ProtectedRoute>
                    <ProfileEditPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/submission/purchase/success"
                element={
                  <ProtectedRoute>
                    <SuccessPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/submission/purchase/failure"
                element={
                  <ProtectedRoute>
                    <FailurePage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/videos/"
                element={
                  <ProtectedRoute>
                    <SocialVideo />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/challenge/videos/watching"
                element={
                  <ProtectedRoute>
                    <WatchingPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="challenge/videos/:videoId/interactions"
                element={
                  <ProtectedRoute>
                    <VideoInteractions />
                  </ProtectedRoute>
                }
              />

              <Route
                path="challenge/memberships/cap"
                element={
                  <ProtectedRoute>
                    <CAPMembershipPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </MainLayout>
        </Router>
      </ThemeProvider>
    </PayPalScriptProvider>
  );
};

export default App;
